import { NgModule, ModuleWithProviders, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RuntimeConfigLoaderService } from './runtime-config-loader.service';
import { RuntimeConfig, RuntimeConfigInjectionToken } from './runtime-config';

export function initRuntimeConfig(configSvc: RuntimeConfigLoaderService) {
	return (): Promise<any> => {
    return configSvc.loadConfig();
  }
}

export function appConfigFactory<T>(configService: RuntimeConfigLoaderService): T {
	return configService.getConfig() as T;
}

@NgModule({
	imports: [HttpClientModule],
	providers: [RuntimeConfigLoaderService],
})
export class RuntimeConfigLoaderModule {
	static forRoot(config: RuntimeConfig): ModuleWithProviders {
		return {
			ngModule: RuntimeConfigLoaderModule,
			providers: [
				{
					provide: RuntimeConfigInjectionToken,
					useValue: config,
				},
				{
					provide: APP_INITIALIZER,
					useFactory: initRuntimeConfig,
					deps: [RuntimeConfigLoaderService],
					multi: true,
				},
				RuntimeConfigLoaderService,
			],
		};
	}
}
